export const validationConstants = {
    PINACTIVATEUSER_REQUEST: 'PINACTIVATEUSER_GETALL_REQUEST',
    PINACTIVATEUSER_SUCCESS: 'PINACTIVATEUSER_GETALL_SUCCESS',
    PINACTIVATEUSER_FAILURE: 'PINACTIVATEUSER_GETALL_FAILURE',

    VALCAPTCHA_REQUEST: 'VALCAPTCHA_REQUEST',
    VALCAPTCHA_SUCCESS: 'VALCAPTCHA_SUCCESS',
    VALCAPTCHA_FAILURE: 'VALCAPTCHA_FAILURE',

    VALIDATECHANGPASS_REQUEST: 'VALIDATECHANGPASS_REQUEST',
    VALIDATECHANGPASS_SUCCESS: 'VALIDATECHANGPASS_SUCCESS',
    VALIDATECHANGPASS_FAILURE: 'VALIDATECHANGPASS_FAILURE',

    VALIDATE_DOC_REQUEST: 'VALIDATE_DOC_REQUEST',
    VALIDATE_DOC_SUCCESS: 'VALIDATE_DOC_SUCCESS',
    VALIDATE_DOC_FAILURE: 'VALIDATE_DOC_FAILURE',
}